import { LogoAB } from "@ea/ui/brandingIcons/LogoAB";
import { LogoAB02 } from "@ea/ui/brandingIcons/LogoAB02";
import { LogoEA } from "@ea/ui/brandingIcons/LogoEA";
import { LogoEA02 } from "@ea/ui/brandingIcons/LogoEA02";
import { LogoEA03 } from "@ea/ui/brandingIcons/LogoEA03";
import { LogoEE } from "@ea/ui/brandingIcons/LogoEE";
import { LogoEE02 } from "@ea/ui/brandingIcons/LogoEE02";
import { LogoEE03 } from "@ea/ui/brandingIcons/LogoEE03";
import { LogoXplus } from "@ea/ui/brandingIcons/LogoXplus";
import { LogoXplus02 } from "@ea/ui/brandingIcons/LogoXplus02";
import { LogoXplusWhite } from "@ea/ui/brandingIcons/LogoXplusWhite";
import { LogoPropsType } from "@ea/ui/brandingIcons/types";
import { ApplicationVariant } from "@ea/shared_types/next/ea.enums";

type BrandingImageName =
  | "LogoAB"
  | "LogoAB02"
  | "LogoEA"
  | "LogoEA02"
  | "LogoEA03"
  | "LogoEE"
  | "LogoEE02"
  | "LogoEE03"
  | "LogoXplus"
  | "LogoXplus02"
  | "LogoXplusWhite";

export type BrandingImageLocation = "LoginLogo" | "MainLogo";

type BrandingLogoConfig = {
  imageName: BrandingImageName;
  defaultProps?: Partial<LogoPropsType>;
};

const brandingLogoMap: Record<
  ApplicationVariant,
  Record<BrandingImageLocation, BrandingLogoConfig>
> = {
  [ApplicationVariant.EA]: {
    LoginLogo: {
      imageName: "LogoEA",
      defaultProps: { textColor: "white", width: "100%", height: "auto" },
    },
    MainLogo: {
      imageName: "LogoEA",
    },
  },
  [ApplicationVariant.AB]: {
    LoginLogo: {
      imageName: "LogoAB",
      defaultProps: { width: "100%", height: 100 },
    },
    MainLogo: {
      imageName: "LogoAB02",
    },
  },
};

type GetBrandingImageOptions = LogoPropsType & {
  imageName?: BrandingImageName;
  appVariant?: ApplicationVariant;
  location?: BrandingImageLocation;
};

export const getBrandingImage = (options: GetBrandingImageOptions): React.JSX.Element => {
  const { imageName, appVariant, location, ...props } = options;

  let finalImageName: BrandingImageName;
  let defaultProps: Partial<LogoPropsType> = {};

  if (appVariant && location) {
    const config =
      brandingLogoMap[appVariant]?.[location] ?? brandingLogoMap[ApplicationVariant.EA][location];
    finalImageName = config.imageName;
    defaultProps = config.defaultProps ?? {};
  } else {
    finalImageName = imageName!;
  }

  const finalProps = { ...defaultProps, ...props };

  switch (finalImageName) {
    case "LogoEA03":
      return <LogoEA03 {...finalProps} />;
    case "LogoAB":
      return <LogoAB {...finalProps} />;
    case "LogoAB02":
      return <LogoAB02 {...finalProps} />;
    case "LogoEA":
      return <LogoEA {...finalProps} />;
    case "LogoEA02":
      return <LogoEA02 {...finalProps} />;
    case "LogoEE":
      return <LogoEE {...finalProps} />;
    case "LogoEE02":
      return <LogoEE02 {...finalProps} />;
    case "LogoEE03":
      return <LogoEE03 {...finalProps} />;
    case "LogoXplus":
      return <LogoXplus {...finalProps} />;
    case "LogoXplus02":
      return <LogoXplus02 {...finalProps} />;
    case "LogoXplusWhite":
      return <LogoXplusWhite {...finalProps} />;
    default:
      throw new Error(`No SVG found for image name: ${finalImageName}`);
  }
};

const brandingImageSrcMap: Record<ApplicationVariant, string> = {
  [ApplicationVariant.EA]: "/img/lp_bg_60.jpg",
  [ApplicationVariant.AB]: "/img/lp_bg_ab.jpg",
};

export const getBrandingImageSrc = (appVariant: ApplicationVariant): string => {
  return brandingImageSrcMap[appVariant] ?? brandingImageSrcMap[ApplicationVariant.EA];
};
